export default {
    methods: {
        getLocalisedText() {
            switch (this.$store.state.language) {
                case "fi":
                    return {
                        instruct0: "Tässä tehtävässä sinun pitää laskea helppoja laskuja ja samalla pitää mielessä kirjaimia.<br><br>Aloitetaan harjoittelemalla kirjainten muistamista.<br><br>",
                        instruct1: "Näytölle ilmestyy kirjaimia yksi kerrallaan.<br><br>Yritä muistaa kaikki kirjaimet, jotka näytetään.",
                        instruct2: "Nyt saat harjoitella laskutehtäviä. Ne voivat näyttää tältä:<br><br><b>1 + 2</b><br><br>Laske lasku päässälaskuna.<br><br>Paina “Jatka”, kun tiedät vastauksen laskuun.", // svara så snabbt som möjligt
                        instruct3: "Tämän jälkeen saat ehdotuksen oikeaksi vastaukseksi, esimerkiksi <b>4</b>.<br><br> Joskus vastaus on oikein ja joskus väärin.<br><br>Onko 1 + 2 = 4?<br><br>Vastaa painamalla “Oikein” tai “Väärin” nappulaa.",
                        instruct4: "Hyvä! Nyt saat harjoitella laskutehtäviä ja kirjainten muistamista samanaikaisesti.<br><br>Sinulla on vain vähän aikaa ratkaista laskutehtävä.",
                        instruct5: "Tämä mittari näyttää oletko vastannut oikein vai väärin laskutehtäviin.<br><br>Yritä vastata oikein niin moneen tehtävään kuin mahdollista, jotta viisari pysyisi vihreällä alueella.",
                        instruct6: "No niin, oletko valmis?<br><br>Yritä ratkaista lasku oikein ja muistaa kaikki kirjaimet.",
                        instruct7: "Nyt olet tehnyt kaikki harjoitustehtävät!<br><br>Nyt tulevat varsinaiset tehtävät. Ne ovat samanlaisia kuin ne, joita juuri harjoittelit.<br><br>Yritä ratkaista lasku oikein ja muistaa kaikki kirjaimet.",
                        letter_response_instr: "Paina kirjaimia siinä järjestyksessä missä ne näytettiin.",
                        current_results: (lnum, lcorr, qnum, qcorr) => {
                            var str = "";
                            if (lnum > 0) {
                                if (lcorr == lnum) {
                                    if (lnum > 2) {
                                        str += `Muistit <font color="#88FF88">kaikki ${lcorr} kirjainta</font>`;
                                    }
                                    else {
                                        str += `Muistit <font color="#88FF88">kaikki kirjaimet</font>`;
                                    }
                                }
                                else {
                                    str += `Kaikki kirjaimet <font color="#FF8888">eivät olleet oikein</font>`;
                                }
                                str += "<br><br>";
                            }
                            if (qnum > 0) {
                                if (qcorr == 0) str += `<font color="#FF8888">Vastasit väärin joihinkin laskuista</font>`;
                                else if (qcorr == 1) str += `Sait oikein <font color="#88FF88">1 laskun</font>`;
                                else if (qcorr > 1) {
                                    if (qcorr == qnum && qnum > 2)
                                        str += `Sait oikein <font color="#88FF88">kaikki ${qcorr} laskua</font>`;
                                    else
                                        str += `Sait oikein <font color="#88FF88">${qcorr} laskua</font>`;
                                }
                            }
                            return str;
                        },
                        too_slow: "Yritä nopeammin!",
                        continue_: "Jatka →",
                        true_: "Oikein",
                        false_: "Väärin",
                        correct: "Oikein",
                        incorrect: "Väärin",
                        practice: "Harjoitus",
                        done: "Tehtävä suoritettu!",
                        questions: {
                            // measure speed
                            measure: [
                                ["5 + 4", "9", true], ["3 + 4", "6", false], ["5 + 3", "8", true], ["6 + 3", "9", true],
                                ["7 + 2", "8", false], ["2 + 6", "9", false], ["2 + 5", "7", true], ["2 + 6", "7", false],
                                ["3 + 2", "5", true], ["1 + 7", "7", false], ["8 + 1", "8", false], ["2 + 7", "9", true],
                                ["6 + 2", "9", false], ["4 + 5", "9", true], ["4 + 3", "7", true], ["1 + 6", "8", false],
                            ],
                            // Practice, both
                            practice: [
                                [["2 + 2", "4", true], ["8 + 1", "5", false]],
                                [["4 + 5", "8", false], ["3 + 4", "7", true]],
                                [["3 + 1", "4", true], ["1 + 7", "9", false]],
                            ],
                            test: [
                                // level 2
                                [
                                    [["1 + 8", "9", true], ["3 + 4", "6", false]],
                                    [["2 + 5", "7", true], ["4 + 3", "6", false]],
                                ],
                                // level 3
                                [
                                    [["5 + 2", "7", true], ["1 + 8", "9", true], ["2 + 5", "9", false]],
                                    [["5 + 2", "7", true], ["6 + 1", "9", false], ["5 + 1", "6", true]],
                                ],
                                // level 4
                                [
                                    [["3 + 2", "7", false], ["5 + 1", "6", true], ["7 + 2", "9", true], ["2 + 5", "6", false]],
                                    [["6 + 3", "9", true], ["1 + 5", "8", false], ["3 + 6", "8", false], ["5 + 3", "8", true]],
                                ],
                                // level 5
                                [
                                    [["3 + 5", "8", true], ["4 + 3", "6", false], ["5 + 3", "8", true], ["3 + 4", "9", false], ["6 + 3", "9", true]],
                                    [["3 + 2", "4", false], ["1 + 3", "4", true], ["5 + 4", "9", true], ["2 + 4", "6", true], ["6 + 1", "9", false]],
                                ],
                                // level 6
                                [
                                    [["5 + 2", "8", false], ["1 + 2", "3", true], ["3 + 6", "8", false], ["2 + 5", "7", true], ["7 + 2", "9", true], ["2 + 4", "7", false]],
                                    [["3 + 4", "7", true], ["2 + 5", "8", false], ["1 + 6", "6", false], ["5 + 4", "9", true], ["3 + 1", "5", false], ["5 + 3", "8", true]],
                                ],
                                // level 7
                                [
                                    [["3 + 6", "9", true], ["3 + 2", "8", false], ["2 + 3", "4", false], ["3 + 6", "9", true], ["4 + 3", "7", true], ["2 + 5", "8", false], ["5 + 2", "9", false]],
                                    [["3 + 2", "8", false], ["2 + 3", "5", true], ["2 + 5", "6", false], ["3 + 4", "8", false], ["4 + 3", "7", true], ["1 + 7", "8", true], ["3 + 2", "7", false]],
                                ],
                            ]
                        },
                    };
                case "sv":
                default:
                    return {
                        instruct0: "I uppgiften som kommer snart ska du räkna enkla mattetal och samtidigt komma ihåg bokstäver.<br><br>Men vi börjar med att öva på att komma ihåg bokstäver.<br><br>",
                        instruct1: "Bokstäver kommer att visas, en i taget.<br><br>Försök att komma ihåg alla bokstäver som visas.",
                        instruct2: "Nu kommer du få öva på räkneuppgifterna. De kan se ut så här:<br><br><b>(2·2) + 1</b><br><br>Räkna på en gång ut svaret i huvudet.<br><br>Tryck på ”Gå vidare” när du räknat ut svaret.", // svara så snabbt som möjligt
                        instruct3: "Du får sedan ett förslag på svar, till exempel <b>4</b>.<br><br> Ibland är förslaget sant och ibland är det falskt.<br><br>Stämmer det att <b>(2·2) + 1</b> är 4?<br><br>Svara genom att trycka på knapparna ”Sant” och ”Falskt”",
                        instruct4: "Okej, bra! Du kommer nu få öva på både räkneuppgifter och att komma ihåg bokstäver på samma gång.<br><br>Du får bara en kort tid på dig att svara rätt på varje räkneuppgift.",
                        instruct5: "Den här mätaren visar om du svarat rätt eller fel på räkneuppgifterna.<br><br>Försök att svara rätt på så många som möjligt så att visaren ligger i det gröna fältet.",
                        instruct6: "Okej, är du redo?<br><br>Försök att både svara rätt och komma ihåg alla bokstäver.",
                        instruct7: "Nu är övningarna slut!<br><br>Nu kommer de riktiga uppgifterna. De är likadana som de du just övat på.<br><br>Försök svara rätt och komma ihåg alla bokstäver.",
                        letter_response_instr: "Tryck på bokstäverna i samma ordning som de visades",
                        current_results: (lnum, lcorr, qnum, qcorr) => {
                            var str = "";
                            if (lnum > 0) {
                                if (lcorr == lnum) {
                                    if (lnum > 2) {
                                        str += `Du kom ihåg <font color="#88FF88">alla ${lcorr} bokstäver</font>`;
                                    }
                                    else {
                                        str += `Du kom ihåg <font color="#88FF88">alla bokstäver</font>`;
                                    }
                                }
                                else {
                                    str += `<font color="#FF8888">Inte alla bokstäver</font> blev rätt`;
                                }
                                str += "<br><br>";
                            }
                            if (qnum > 0) {
                                if (qcorr == 0) str += `<font color="#FF8888">Du svarade inte rätt på några mattetal</font>`;
                                else if (qcorr == 1) str += `Du svarade rätt på <font color="#88FF88">1 mattetal</font>`;
                                else if (qcorr > 1) {
                                    if (qcorr == qnum && qnum > 2)
                                        str += `Du svarade rätt på <font color="#88FF88">alla ${qcorr} mattetal</font>`;
                                    else
                                        str += `Du svarade rätt på <font color="#88FF88">${qcorr} mattetal</font>`;
                                }
                            }
                            return str;
                        },
                        too_slow: "För långsam!",
                        continue_: "Gå vidare →",
                        true_: "Sant",
                        false_: "Falskt",
                        correct: "Rätt",
                        incorrect: "Fel",
                        practice: "Övning",
                        done: "Klart!",
                        questions: {
                            // measure speed
                            measure: [
                                ["(1·2) + 1", "3", true],
                                ["(1/1) - 1", "2", false],
                                ["(7·3) - 3", "18", true],
                                ["(4·3) + 4", "16", true],
                                ["(3/3) + 2", "1", false],
                                ["(2·6) - 4", "6", false],
                                ["(8·9) - 8", "64", true],
                                ["(4·5) - 5", "11", false],
                                ["(4·2) + 6", "14", true],
                                ["(4/4) + 7", "12", false],
                                ["(8·2) - 8", "2", false],
                                ["(2·9) - 9", "9", true],
                                ["(8/2) + 9", "7", false],
                                ["(3·8) - 1", "23", true],
                                ["(6/3) + 1", "3", true],
                                ["(9/3) - 2", "7", false],

                                /*["5 + 4", "9", true], ["3 + 4", "6", false], ["5 + 3", "8", true], ["6 + 3", "9", true],
                                ["7 + 2", "8", false], ["2 + 6", "9", false], ["2 + 5", "7", true], ["2 + 6", "7", false],
                                ["3 + 2", "5", true], ["1 + 7", "7", false], ["8 + 1", "8", false], ["2 + 7", "9", true],
                                ["6 + 2", "9", false], ["4 + 5", "9", true], ["4 + 3", "7", true], ["1 + 6", "8", false],*/
                            ],
                            // Practice, both
                            practice: [
                                [["(3·5) - 2", "17", false], ["(4·2) + 1", "9", true]],
                                [["(5/5) + 7", "12", false], ["(8·2) - 8", "8", true]],
                                [["(1·9) + 1", "10", true], ["(8/2) + 1", "6", false]],
                            ],
                            test_letters: [
                                "TKF",
                                "MQY",
                                "SMYJ",
                                "PHRS",
                                "RQLJT",
                                "SRHKM",
                                "JHFTQP",
                                "YLPKHM",
                                "FKQTRSY",
                                "LPTJKMF",
                                "STHRYMLF",
                                "PFYLQSKT",
                                "RFTMKPQJY",
                                "LSPTMJHYK",
                                /*
                                ["T", "K", "F"],
                                ["M", "Q", "Y"],
                                ["S", "M", "Y", "J"],
                                ["P", "H", "R", "S"],
                                ["R", "Q", "L", "J", "T"],
                                ["S", "R", "H", "K", "M"],
                                ["J", "H", "F", "T", "Q", "P"],
                                ["Y", "L", "P", "K", "H", "M"],
                                ["F", "K", "Q", "T", "R", "S", "Y"],
                                ["L", "P", "T", "J", "K", "M", "F"],
                                ["S", "T", "H", "R", "Y", "M", "L", "F"],
                                ["P", "F", "Y", "L", "Q", "S", "K", "T"],
                                ["R", "F", "T", "M", "K", "P", "Q", "J", "Y"],
                                ["L", "S", "P", "T", "M", "J", "H", "Y", "K"],
                                */
                            ],
                            test: [
                                // ------------------------------
                                // level: 3
                                [["(2·8) + 8", "24", true], ["(5/1) - 2", "3", true], ["(8/4) - 1", "1", true]],

                                [["(3/3) + 2", "2", true], ["(5·8) - 4", "39", false], ["(2·3) + 2", "9", false]],

                                // ------------------------------
                                // level: 4
                                [["(4·9) - 6", "31", false], ["(5·2) - 7", "5", false], ["(9·5) - 7", "38", true], ["(2·6) - 4", "8", true]],

                                [["(2·7) + 4", "18", true], ["(1·8) + 3", "10", false], ["(4·3) + 2", "14", true], ["(8/1) + 1", "8", false]],

                                // ------------------------------
                                // level: 5
                                [["(5·8) + 7", "44", false], ["(3·6) - 5", "16", false], ["(8/8) + 6", "6", false], ["(2/1) + 2", "4", true], ["(1/1) - 1", "0", true]],

                                [["(6·1) - 3", "3", true], ["(4·2) - 2", "6", true], ["(7·7) - 7", "43", false], ["(2·8) - 2", "17", false], ["(3·9) + 3", "30", true]],

                                // ------------------------------
                                // level: 6
                                [["(5·1) - 2", "3", true], ["(5·2) - 7", "4", false], ["(5/5) + 3", "5", false], ["(7·8) - 4", "53", false], ["(1·9) + 4", "10", false], ["(7·8) + 7", "63", true]],
                                [["(7·1) + 1", "8", true], ["(2·5) - 8", "5", false], ["(6/1) - 5", "1", true], ["(1·1) + 3", "2", false], ["(8·5) + 9", "49", true], ["(8·5) - 4", "36", true]],

                                // ------------------------------
                                // level: 7
                                [["(7/7) - 1", "0", true], ["(6/6) + 3", "5", false], ["(1·9) + 8", "17", true], ["(2·7) - 5", "12", false], ["(8/2) + 3", "6", false], ["(6/2) - 2", "1", true], ["(4·3) + 3", "15", true]],

                                [["(8·4) - 5", "30", false], ["(2·8) - 7", "9", true], ["(6·2) - 3", "10", false], ["(9·2) - 2", "16", true], ["(4/2) + 8", "12", false], ["(3·2) + 9", "15", true], ["(3·4) - 7", "8", false]],

                                // ------------------------------
                                // level: 8
                                [["(7·1) - 6", "1", true], ["(9·1) - 7", "3", false], ["(6·8) + 3", "51", true], ["(2/2) - 1", "0", true], ["(7·7) + 7", "58", false], ["(2·6) + 7", "19", true], ["(1·3) - 1", "2", true], ["(4·1) - 3", "4", false]],

                                [["(4·5) - 6", "16", false], ["(3/1) + 2", "5", true], ["(1·6) + 1", "7", true], ["(6/3) + 3", "6", false], ["(2·1) + 1", "2", false], ["(6·4) + 9", "34", false], ["(1·4) - 1", "3", true], ["(5·2) - 5", "6", false]],

                                // ------------------------------
                                // level: 9
                                [["(9·2) - 9", "12", false], ["(7·2) - 4", "10", true], ["(8·8) - 1", "63", true], ["(4/4) + 3", "2", false], ["(5·5) + 5", "30", true], ["(2·5) + 2", "12", true], ["(7/1) - 5", "2", true], ["(4/1) + 1", "5", true], ["(6·3) - 9", "11", false]],

                                [["(6/2) + 7", "10", true], ["(4·5) - 2", "20", false], ["(10/2) + 4", "8", false], ["(6/3) - 1", "1", true], ["(8·7) - 2", "52", false], ["(9·7) + 9", "71", false], ["(4·7) - 8", "24", false], ["(9/3) + 9", "12", true], ["(9·6) - 7", "49", false]],
                            ]
                        },
                    };
            }
        }
    }
}


